// extracted by mini-css-extract-plugin
export default {"container":"L9-z","productName":"M9-z","price":"N9-z","dimensions":"O9-z"};